import { render } from "./Root.vue?vue&type=template&id=275ff6d6"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import "./Root.vue?vue&type=style&index=0&id=275ff6d6&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__